import styled from 'styled-components';

export const Header = styled('h2')`
	margin: 0;
	padding-top: 40px;
	padding-bottom: 25px;
	font-family: 'Segoe UI', Roboto, sans-serif;
`;
export const Container = styled('div')`
	padding: 0 15px;
	background-color: white;
	min-height: 50vh;
	min-width: 50vh;
`;
export const ButtonGroup = styled('div')`
	display: flex;
	flex-flow: row wrap;
	align-items: center;
	justify-content: flex-end;
	width: 100%;
	padding-top: 20px;
	padding-bottom: 30px;
`;
